export const hasAssociatedLooks = ({ looksProducts }) =>
  looksProducts?.some((product) => product.isHero === false);
